module.exports = __webpack_public_path__ + "static/media/screenpop-notification.765be77c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/screenpop-notification.mp3
// module id = 2027
// module chunks = 0